<template>
  <a-config-provider :locale="localeCN">
    <div id="nfs">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import enquireScreen from './utils/device'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

export default {
  name: 'NFS',
  data () {
    return {
      localeCN: zhCN
    }
  },
  created () {
    let _this = this
    enquireScreen(isMobile => {
      _this.$store.commit('setting/setDevice', isMobile)
    })
  }
}
</script>
<style lang="less">
:global {
  .dragable-ghost {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .dragable-chose {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .dragable-drag {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
}

::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

::-webkit-scrollbar-track {
  border-radius: 1px;
}

::-webkit-scrollbar-thumb {
  border-radius: 1px;
  background: rgba(0, 0, 0, 0.2);
}

.multi-page {
  margin: 0px;
}

.single-page {
  margin: 12px 0px 0px 0px;
}

.card-area {
  width: 100%;
}

.not-menu-page {
  background: #fff;
  padding: 16px 32px;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}

.ant-btn,
.ant-input,
.input,
.ant-pagination-item,
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link,
.ant-tag,
.ant-modal-content,
.ant-select-selection,
.ant-select-dropdown,
.ant-input-group-addon,
.ant-input-number-input,
.ant-input-number,
.ant-pagination-options-quick-jumper input,
.ant-alert {
  border-radius: 2px !important;
}

.ant-btn-group > .ant-btn,
.ant-btn-group > span > .ant-btn {
  border-radius: 0px !important;
}

.ant-btn-group > .ant-btn:first-child,
.ant-btn-group > span:first-child > .ant-btn {
  border-bottom-left-radius: 2px !important;
  border-top-left-radius: 2px !important;
}

.ant-btn-group > .ant-btn:last-child,
.ant-btn-group > span:last-child > .ant-btn {
  border-bottom-right-radius: 2px !important;
  border-top-right-radius: 2px !important;
}

.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab,
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-radius: 3px 3px 0 0 !important;
}

.ant-card-wider-padding .ant-card-body {
  padding: 5px 10px !important;
}

.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.ant-modal-header {
  border-bottom-color: #fff !important;
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) inset !important;
}

.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-item {
  margin-top: 0 !important;
}
.ant-menu-dark,
.ant-menu-dark .ant-menu-sub {
  background: #393e46 !important;
}

.ant-table-row-expand-icon {
  margin-right: 1rem !important;
}

:root .ant-tabs-tab-prev {
  border: 1px solid #e8e8e8;
  border-radius: 3px 0 0 0;
  background: #fafafa;
}
.ant-card-loading {
  &:after {
    width: 0 !important;
  }
}
.ant-tabs-tab-next.ant-tabs-tab-arrow-show {
  border: 1px solid #e8e8e8;
  border-radius: 0 3px 0 0;
  background: #fafafa;
}
.ant-layout-header,
.system-top-menu {
  height: 59px !important;
  line-height: 59px !important;
}
.ant-form-item {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 0 solid #ccc !important;
}
.ant-form-explain {
  font-size: 11px !important;
}
.ant-drawer-content {
  padding: 0px;
}
.ant-drawer-title {
  font-size: 14px;
}
.ant-drawer-body {
  overflow: hidden;
  padding: 0 0 3rem 0 !important;
}
.ant-divider-inner-text {
  font-size: 12px;
  color: rgb(119, 119, 119);
  font-weight: 500;
}
.page-tabs .ant-tabs-close-x {
  color: #fff !important;
  margin-left: 0.3rem !important;
}
.page-tabs:hover .ant-tabs-close-x {
  color: #f95476 !important;
}
.drawer-bootom-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.ant-descriptions-item-label {
  width: 120px;
}
.ant-descriptions-item-label,
.ant-descriptions-item-content {
  font-size: 12px;
}
.search {
  margin-bottom: 0.5rem !important;
}
i {
  font-size: 0.8rem;
}
p {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
}

.ant-cascader-picker input,
.ant-cascader-picker-label,
.ant-cascader-menus li {
  font-size: 12px !important;
}
@media screen and (min-width: 1400px) {
  p,
  .ant-pagination,
  .ant-form,
  .ant-dropdown,
  .ant-form-item,
  .ant-select,
  .ant-breadcrumb,
  .ant-form label,
  .ant-btn,
  .ant-table,
  .ant-menu-vertical .ant-menu-item,
  .ant-menu-vertical-left .ant-menu-item,
  .ant-menu-vertical-right .ant-menu-item,
  .ant-menu-inline .ant-menu-item,
  .ant-menu-vertical .ant-menu-submenu-title,
  .ant-menu-vertical-left .ant-menu-submenu-title,
  .ant-menu-vertical-right .ant-menu-submenu-title,
  .ant-menu-inline .ant-menu-submenu-title {
    font-size: 12px !important;
  }
  .ant-card-head {
    font-size: 14px;
  }
  .ant-input,
  .ant-select-dropdown-menu-item,
  .ant-collapse,
  .ant-upload,
  .ant-dropdown-menu-item {
    font-size: 12px !important;
  }
  .page-tabs .ant-tabs-nav-container {
    font-size: 12px !important;
  }
  .ant-tag {
    font-size: 80% !important;
  }
  .ant-badge-status-text {
    font-size: 12px !important;
  }
  .ant-popover {
    font-size: 12px !important;
  }
  .ant-tree {
    font-size: 12px !important;
  }
  .ant-table-thead > tr > th {
    font-size: 12px !important;
    font-weight: normal !important;
    text-align: center !important;
    padding: 12px !important;
  }
  .ant-table-tbody > tr > td {
    padding: 12px !important;
  }
  .ant-table-small > tr > td {
    padding: 6px 10px !important;
  }
  .ant-card-body {
    padding: 16px;
  }
  .ant-modal-title {
    font-size: 14px !important;
    font-weight: normal;
  }
}

@media screen and (max-width: 1399px) {
  p,
  .ant-pagination,
  .ant-form,
  .ant-dropdown,
  .ant-form-item,
  .ant-select,
  .ant-breadcrumb,
  .ant-form label,
  .ant-btn,
  .ant-table,
  .ant-menu-vertical .ant-menu-item,
  .ant-menu-vertical-left .ant-menu-item,
  .ant-menu-vertical-right .ant-menu-item,
  .ant-menu-inline .ant-menu-item,
  .ant-menu-vertical .ant-menu-submenu-title,
  .ant-menu-vertical-left .ant-menu-submenu-title,
  .ant-menu-vertical-right .ant-menu-submenu-title,
  .ant-menu-inline .ant-menu-submenu-title {
    font-size: 12px !important;
  }
  .ant-card-head {
    font-size: 14px;
  }
  .ant-input,
  .ant-select-dropdown-menu-item,
  .ant-collapse,
  .ant-upload,
  .ant-dropdown-menu-item {
    font-size: 12px !important;
  }
  .page-tabs .ant-tabs-nav-container {
    font-size: 12px !important;
  }
  .ant-tag {
    font-size: 80% !important;
  }
  .ant-badge-status-text {
    font-size: 12px;
  }
  .ant-popover {
    font-size: 12px !important;
  }
  .ant-table-thead > tr > th {
    font-size: 12px !important;
    font-weight: normal !important;
    text-align: center !important;
    padding: 12px !important;
  }
  .ant-table-tbody > tr > td {
    padding: 12px !important;
  }
  .ant-table-small > tr > td {
    padding: 6px 10px !important;
  }
  .ant-card-body {
    padding: 16px;
  }
  .ant-modal-title {
    font-size: 14px !important;
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// NFS.vue?6e63ffdd